import { useAsync } from 'react-async-hook';
import useConstant from 'use-constant';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import axios from 'axios';
import { useState } from 'react';

axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector(
  'meta[name="csrf-token"]',
).content;

const userStoreLocation = async config => {
  if (config === null) return undefined;

  const { url, method } = config;

  return await axios(url, {
    method: method,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json, text/javascript, */*; q=0.01',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then(({ data }) => ({
      success: true,
      data,
    }))
    .catch(({ response }) => {
      if (response) {
        return { success: false, data: response };
      } else {
        return {
          success: false,
          data: {
            data: { message: 'Network error' },
            status: 500,
            statusText: 'Network error',
          },
        };
      }
    });
};

const useUserStoreLocation = () => {
  const [config, setConfig] = useState(null);

  const debounceUserStoreLocation = useConstant(() =>
    AwesomeDebouncePromise(userStoreLocation, 300),
  );

  const response = useAsync(async () => debounceUserStoreLocation(config), [
    config,
  ]);

  return {
    response,
    setConfig,
  };
};

export default useUserStoreLocation;
